import styled from 'styled-components'
import { Badge } from 'antd'

export const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 20;
  /* Page container is a flex column; prevent the header from being
     squeezed when the viewport is short so CasesTable/Logs absorb
     the remaining space instead. */
  flex-shrink: 0;
  background-color: rgb(255 255 255);
  border-bottom: 1px solid rgb(226 232 240);
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem;
  }
`

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  color: rgb(15 23 42);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const Subtitle = styled.p`
  font-size: 13px;
  color: rgb(100 116 139);
  margin: 0;
  margin-top: 0.125rem;
`

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
  }
`

export const ControlGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background-color: rgb(243 244 246);
  border-radius: 9999px;
  padding: 0.25rem;
`

export const PillButton = styled.button`
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
  font-weight: ${props => props.$active ? '500' : '400'};
  white-space: nowrap;
  
  background-color: ${props => props.$active ? 'rgb(255 255 255)' : 'transparent'};
  color: ${props => props.$active ? 'rgb(17 24 39)' : 'rgb(107 114 128)'};
  box-shadow: ${props => props.$active ? '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)' : 'none'};

  &:hover {
    background-color: ${props => props.$active ? 'rgb(255 255 255)' : 'rgba(255, 255, 255, 0.5)'};
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    padding: 0.25rem 0.625rem;
    font-size: 12px;
  }
`

export const PinInput = styled.input`
  width: 80px;
  height: 32px;
  padding: 0.375rem 0.75rem;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 0.375rem;
  border: 1px solid rgb(226 232 240);
  background-color: rgb(255 255 255);
  color: rgb(15 23 42);
  outline: none;
  transition: all 0.15s ease;

  &::placeholder {
    color: rgb(148 163 184);
  }

  &:focus {
    border-color: rgb(5 150 105);
    box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1);
  }

  &:disabled {
    background-color: rgb(248 250 252);
    color: rgb(148 163 184);
    border-color: rgb(226 232 240);
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:disabled::placeholder {
    color: rgb(203 213 225);
  }

  @media (max-width: 768px) {
    width: 70px;
    font-size: 11px;
  }
`

export const StyledBadge = styled(Badge)`
  margin-left: 5px;
`
